import styled from 'styled-components'

export const Icon = styled.i`
    display: inline-block;
`
